import { createFileRoute } from "@tanstack/react-router";
import { LayersThree01 } from "@untitledui/icons";
import { RequiredAttachmentsField } from "@/features/attachment-requirements/required-attachments-field";
import { EntityTypeDetailsPanel } from "@/features/entity-types/components/entity-type-details-panel";
import { RequiredLocationField } from "@/features/entity-types/components/required-location-field";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { resolveIconComponent } from "@/utils/icon-catalog";
import { useRecordTypeDrawerContext } from "@/utils/record-type-detail/record-type-drawer-context";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/details",
)({
	component: AdminRecordTypeDetailsTab,
});

function AdminRecordTypeDetailsTab() {
	const { t } = useAppTranslation();
	const {
		recordType,
		canEdit,
		persistDetails,
		locationRequired,
		persistLocationRequired,
	} = useRecordTypeDrawerContext();

	const sourceLabel = recordType.defaultType
		? t("admin.recordTypes.table.source.system")
		: t("admin.recordTypes.table.source.custom");

	return (
		<EntityTypeDetailsPanel
			labels={{
				name: t("admin.recordTypes.drawer.details.fields.name"),
				icon: t("admin.recordTypes.drawer.details.fields.icon"),
				source: t("admin.recordTypes.drawer.details.fields.source"),
				lifecycle: "",
				id: t("admin.recordTypes.drawer.details.fields.id"),
				description: t("admin.recordTypes.drawer.details.fields.description"),
				nameRequired: t("admin.entityTypes.drawer.details.nameRequired"),
				saveFailed: t("admin.entityTypes.drawer.details.saveFailed"),
			}}
			name={recordType.name}
			icon={recordType.icon}
			description={recordType.description}
			sourceLabel={sourceLabel}
			showLifecycle={false}
			id={recordType.id}
			resolveIcon={(icon) => resolveIconComponent(icon ?? "") ?? LayersThree01}
			iconEditable
			locationRequiredField={
				<RequiredLocationField
					value={locationRequired}
					canEdit={canEdit}
					onChange={persistLocationRequired}
				/>
			}
			attachmentsField={
				<RequiredAttachmentsField
					entityKind="record"
					typeId={recordType.id}
					requirement={recordType.attachmentRequirement}
				/>
			}
			canEdit={canEdit}
			onPersist={persistDetails}
			data-testid="recordtype-details-panel"
		/>
	);
}
